import React from "react";
import { Box } from "@mui/material";
import { SaveButton } from "app/shared/ui";

// Botón de guardar fijo al pie de cualquier editor de automatización.
const EditorSaveBar = ({ saving, disabled, onSave, label = "Guardar automatización" }) => (
    <Box
        sx={{
            position: "sticky",
            bottom: { xs: 16, md: 24 },
            zIndex: (theme) => theme.zIndex.fab,
            display: "flex",
            justifyContent: "flex-end",
            mt: 2,
            pointerEvents: "none",
        }}>
        <SaveButton
            loading={saving}
            disabled={disabled}
            onClick={onSave}
            sx={{
                minHeight: 46,
                px: 2.5,
                borderRadius: 999,
                boxShadow: "0 16px 36px rgba(103, 58, 183, 0.26)",
                pointerEvents: "auto",
            }}>
            {saving ? "Guardando" : label}
        </SaveButton>
    </Box>
);

export default EditorSaveBar;
